﻿ 

class StockSearchItem {
    constructor(el, index) {
        this.render(el, index);
    }


     


    handle__CLICK(event, panel) {
        
        if (this.current) {
            if (this.current === panel) {
                panel.close();
                this.current = null;
            }
            else {
                this.current.close();
                panel.open()
                this.current = panel;
            }
            return true;
        }
         panel.open();
         this.current = panel;
 
        
    }

    render(el, index) {
        this.element = $(el);
        this.sort = this.element.find('[data-ref="#stock-finder-sort"]');
        this.refine = this.element.find('[data-ref="#stock-finder-refine"]');

        this.sortPanel =  new MobilePanelSet(this.sort);
        this.refinePanel = new MobilePanelSet(this.refine);

       // this.sortPanel = $(this.sort.data('ref'));
       // this.refinePanel = $(this.refine.data('ref'));


        this.element.on('mobile-panel-click',  this.handle__CLICK.bind(this));

        this.current = null;

    
    }

}
class MobilePanelSet {

    open() {
        this.panel.addClass("c-stocksearch__mobile-panel--open");
        this.button.addClass("c-stocksearch__mobile-trigger--active");
    }

    close() {
        this.panel.removeClass("c-stocksearch__mobile-panel--open");
        this.button.removeClass("c-stocksearch__mobile-trigger--active");
    }

    button__CLICK() {
        this.button.trigger('mobile-panel-click', [this])
    }

    constructor(element) {
        this.button = element;
        this.panel = $(this.button.data('ref'));

        this.button.on('click', this.button__CLICK.bind(this));
    }

}


class StockSearch {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }
 
    render(el, index) {
        new StockSearchItem(el, index);
    }
}

export default StockSearch;